import React from "react"
import PropTypes from "prop-types"

import { isRestaurant, isEntradas, isCompra } from "../../tags.js";
import { mixArray, topBy } from "../../../../lib/Tools.js"

function getRecommendations(products) {
  const a = topBy(3, products.filter(isRestaurant), x => x && x.rank)
  const b = topBy(3, products.filter(isEntradas), x => x && x.rank)
  const c = topBy(3, products.filter(isCompra), x => x && x.rank)

  return mixArray([ a, b, c ])
}

const Recommendations = ({ hideElements, products, onClick }) => (
  <div 
    className="lista-lugares"
    style={{ display: hideElements ? "none" : "flex" }}
  >
    {
      getRecommendations(products).map(product => (
        <div key={product._id} className="lista-lugares-item">
          <div onClick={() => onClick(product)}>
            <div className="envoltorio2">
              <img className="image" src={product.foreground.image} />
              <div className="text">
                <div>{product.chName}</div>
              </div>
            </div>
          </div>
        </div>
      ))
    }
  </div>
)

Recommendations.propTypes = {
  hideElements: PropTypes.bool,
  products: PropTypes.arrayOf(PropTypes.object).isRequired,
  onClick: PropTypes.func.isRequired
}

Recommendations.defaultProps = {
  hideElements: false
}

export default Recommendations



// WEBPACK FOOTER //
// ./src/app/catalogo/transportation/components/Recommendations.jsx